export default __webpack_public_path__ + "static/Lato-Medium-08eb0932dc2145b3f6b23d1eeb9e22f4.woff";